import {Injectable} from '@angular/core';
import {LoadingController} from '@ionic/angular';
import {BehaviorSubject} from 'rxjs';


export enum CustomLoaderObjEnum {
    Image, Video, Lottie
}

export interface CustomLoaderObjOption {
    type: CustomLoaderObjEnum;
    url: string;
}

@Injectable({
    providedIn: 'root'
})
export class LoadingService {
    isLoading = false;

    showCustomLoader: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
    customLoaderObj: BehaviorSubject<CustomLoaderObjOption> = new BehaviorSubject<CustomLoaderObjOption>(null);

    constructor(public loadingController: LoadingController) {
    }

    async present(message: string = 'در حال بارگذاری') {
        this.isLoading = true;
        return await this.loadingController.create({
            message: message,
            duration: 120000
        }).then(a => {
            a.present().then(() => {
                console.log('presented');
                if (!this.isLoading) {
                    a.dismiss().then(() => console.log('abort presenting'));
                }
            });
        });
    }

    async customPresent(obj: CustomLoaderObjOption) {
        this.customLoaderObj.next(obj);
        this.showCustomLoader.next(true);
        // this.isLoading = true;
    }

    async dismissCustom() {
        this.customLoaderObj.next(null);
        this.showCustomLoader.next(false);
    }


    async dismiss() {
        this.isLoading = false;
        return await this.loadingController.dismiss().then(() => console.log('dismissed'));
    }
}
